import { render, staticRenderFns } from "./pro-chiose-tab-structure.vue?vue&type=template&id=c23e6b24&scoped=true";
import script from "./pro-chiose-tab-structure.vue?vue&type=script&lang=jsx";
export * from "./pro-chiose-tab-structure.vue?vue&type=script&lang=jsx";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "c23e6b24", null);
export default component.exports;